import { ConcreteEncodable } from "./ConcreteEncodable";

import { TelemetrySubscriptionCatalogueImplEncoder } from "../../encoder/TelemetrySubscriptionCatalogueImplEncoder";

import * as CubiqTS from "../../index";
import { TelemetrySubscriptionCatalogue } from "../TelemetrySubscriptionCatalogue";

export class TelemetrySubscriptionCatalogueImpl
  extends ConcreteEncodable
  implements TelemetrySubscriptionCatalogue
{
  public static enType: string = "com.bcdfx.sysmon.impl.TelemetrySubscriptionCatalogueImpl";

  /*FID=1*/
  public consumerChannel: string;
  /*FID=2*/
  public catalogueEntries: Array<CubiqTS.TelemetryCatalogueEntry> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TelemetrySubscriptionCatalogueImplEncoder.Instance;
    this.setEncodableType(TelemetrySubscriptionCatalogueImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TelemetrySubscriptionCatalogueImpl[" +
      "consumerChannel=" +
      this.consumerChannel +
      "catalogueEntries=" +
      this.catalogueEntries +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
